import { Button } from "@remo-co/ui-core/src/components/Button";
import { IconButton } from "@remo-co/ui-core/src/components/IconButton";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { Lottie } from "@remo-co/ui-core/src/components/Lottie";
import { Close as CloseIcon } from "@remo-co/ui-core/src/icons/Close";
import { useI18n } from "i18n";
import { useShuffleAttendees } from "modules/shuffleAttendees/hooks/useShuffleAttendees";
import { useSelector } from "react-redux";
import {
  selectCurrentEventId,
  selectIsEventManager,
} from "modules/event/selectors";
import { Dialog } from "@remo-co/ui-core/src/components/Dialog";
import { useAppDispatch } from "store/hooks";
import ShuffleAnimation from "modules/shuffleAttendees/assets/shuffle_anim.json";
import { Box } from "@remo-co/ui-core/src/components/Box";
import { useStartShuffle } from "modules/shuffleAttendees/hooks/useStartShuffle/useStartShuffle";
import { DialogTitle } from "@remo-co/ui-core/src/components/DialogTitle";
import {
  hideShuffleAttendeesCountdownDialog,
  showShuffleAttendeesCountdownBanner,
} from "modules/shuffleAttendees/redux/actions";
import { ShuffleCountdownTimer } from "modules/shuffleAttendees/components/ShuffleCountdownTimer";
import { styles } from "./styles";

export const ShuffleAttendeesCountdownDialog = () => {
  const { t } = useI18n(["common", "event"]);
  const dispatch = useAppDispatch();
  const hasEventManagerAccess = useSelector(selectIsEventManager);
  const currentEventId = useSelector(selectCurrentEventId);
  const { cancelShuffleAttendeesDoc } = useShuffleAttendees();

  const { startShuffle } = useStartShuffle();

  const handleClose = () => {
    dispatch(hideShuffleAttendeesCountdownDialog());
    dispatch(showShuffleAttendeesCountdownBanner());
  };

  const handleCountdownEnd = () => {
    dispatch(hideShuffleAttendeesCountdownDialog());
    startShuffle();
  };

  const cancelShuffle = () => {
    if (!currentEventId) return;

    cancelShuffleAttendeesDoc(currentEventId);
  };

  return (
    <div data-testid="shuffle-countdown-dialog">
      <Dialog
        open
        onClose={handleClose}
        sx={styles.shuffleAttendeesCountdownCtn}
        hideBackdrop
      >
        <DialogTitle sx={styles.dialogTitle}>
          <IconButton
            aria-label={t("aria.label.close")}
            sx={styles.closeButton}
            onClick={handleClose}
            size="large"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Box sx={styles.content}>
          <Box>
            <Lottie animationData={ShuffleAnimation} />
          </Box>
          <Typography variant="h5">
            {t("event:table.seat.shuffle.begin")}
          </Typography>
          <Typography variant="body1">
            {t("event:wrap.conversation.table")}
          </Typography>
          <ShuffleCountdownTimer
            size={50}
            onCountdownEnd={handleCountdownEnd}
          />
          {hasEventManagerAccess && (
            <Button
              data-testid="cancel-shuffle"
              size="lg"
              variant="warning"
              onClick={cancelShuffle}
            >
              <span>{t("event:cancel.shuffle")}</span>
            </Button>
          )}
          <Button
            data-testid="handle-close-button"
            sx={styles.minimizeShufflingBtn}
            size="lg"
            variant="secondary"
            color="blue"
            onClick={handleClose}
          >
            <span>{t("event:minimize")}</span>
          </Button>
        </Box>
      </Dialog>
    </div>
  );
};
